import { render, staticRenderFns } from "./CopyStyleNumber.vue?vue&type=template&id=ae169a56&scoped=true"
import script from "./CopyStyleNumber.vue?vue&type=script&lang=js"
export * from "./CopyStyleNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae169a56",
  null
  
)

export default component.exports